export default __webpack_public_path__ + "static/media/FootfallImg.1f6171c5.svg";